// Prompt 18 A3 — static "QuickBooks disconnected" page.
// Public: no auth guard, no API call, no session needed. Linked from
// Intuit app profile ("Disconnect Confirmation URL").
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import Footer from "../components/Footer";

export default function QboDisconnected() {
  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col font-sans">
      <main className="flex-1 w-full max-w-xl mx-auto px-6 pt-24 pb-16"
            data-testid="qbo-disconnected-page">
        <div className="card-flat p-10 text-center">
          <CheckCircle2 className="mx-auto text-emerald-600" size={44} />
          <h1 className="font-display text-2xl font-semibold mt-6">
            QuickBooks has been disconnected from Lingua Franca
          </h1>
          <p className="text-base text-neutral-600 mt-3 leading-relaxed">
            No more data will be read or written. You can reconnect any time.
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <Link to="/qbo/connect"
                  data-testid="qbo-reconnect-btn"
                  className="btn-primary inline-flex items-center">
              Reconnect to QuickBooks
            </Link>
            <Link to="/contact" className="text-sm text-neutral-600 underline">
              Contact support
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
